const validateEmailHandler = (_: unknown, value: string) => {
  // Custom email validation logic
  if (value && !/^[\w-.]+@([\w-]+\.)+[\w-]{2,}$/.test(value)) {
    return Promise.reject('Please enter a valid email address!')
  }
  return Promise.resolve()
}

const validateTelephoneNumberHandler = (_: unknown, value: string) => {
  if (value) {
    // Regular expression to check if the input might be a valid telephone number
    const telephonePattern = /^\+?[0-9\s]+$/

    // Remove spaces from the input value before validation
    const sanitizedValue = value?.replace(/\s/g, '')

    // Check if the input matches the telephone pattern
    if (!telephonePattern.test(sanitizedValue)) {
      return Promise.reject('Please enter a valid telephone number!')
    }
  }

  return Promise.resolve()
}

const isRequired = {
  required: true,
  message: 'Please complete this required field.',
}

const validateEmail = {
  validator: validateEmailHandler,
}

const validateTelephoneNumber = {
  validator: validateTelephoneNumberHandler,
}

const selectOption = {
  required: true,
  message: 'Please select an option from the dropdown menu.',
}

const iressDate = {
  pattern: /^\d{4}-(0[1-9]|1[0-2])$/,
  message: 'Date must be in the format YYYY-MM',
}

const inheritanceProtectPercentage = {
  validator: (_: unknown, value: number) => {
    if (value < 1 || value > 99) {
      return Promise.reject('Percentage of Inheritance protection must be between 1% and 99%.')
    }
    return Promise.resolve()
  },
}

const minimumAge50 = {
  validator: (_: unknown, value: string) => {
    if (value) {
      const selectedDate = new Date(value)
      const today = new Date()
      const age = today.getFullYear() - selectedDate.getFullYear()
      const monthDiff = today.getMonth() - selectedDate.getMonth()
      
      // Adjust age if birthday hasn't occurred this year
      const actualAge = monthDiff < 0 || (monthDiff === 0 && today.getDate() < selectedDate.getDate()) ? age - 1 : age
      
      if (actualAge < 50) {
        return Promise.reject('Minimum age requirement is 50 years.')
      }
    }
    return Promise.resolve()
  },
}

/**
 * Creates a minimum age validator with configurable age and message
 * @param minimumAge - The minimum required age
 * @param customMessage - Optional custom error message
 * @returns Validation object for Ant Design forms
 */
const createMinimumAgeValidator = (minimumAge: number, customMessage?: string) => ({
  validator: (_: unknown, value: string) => {
    if (value) {
      const selectedDate = new Date(value)
      const today = new Date()
      const age = today.getFullYear() - selectedDate.getFullYear()
      const monthDiff = today.getMonth() - selectedDate.getMonth()
      
      // Adjust age if birthday hasn't occurred this year
      const actualAge = monthDiff < 0 || (monthDiff === 0 && today.getDate() < selectedDate.getDate()) ? age - 1 : age
      
      if (actualAge < minimumAge) {
        return Promise.reject(customMessage || `Minimum age requirement is ${minimumAge} years.`)
      }
    }
    return Promise.resolve()
  },
})

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  isRequired,
  selectOption,
  validateEmail,
  validateTelephoneNumber,
  iressDate,
  inheritanceProtectPercentage,
  minimumAge50,
  createMinimumAgeValidator,
}
